<template>
  <div class="col-sm-6 col-lg-4 text-center item mb-4" data-aos="zoom-in-down">
    <router-link tag="a" :to="{ name: 'Product', params: { p_data } }">
      <Loader v-if="loading"></Loader>
      <img
        :src="p_data.imgSrc"
        alt="Image"
        style="max-width: 100%;height: 120px;"
        v-else
      />
    </router-link>
    <h3 class="text-dark">
      <router-link tag="a" :to="{ name: 'Product', params: { p_data } }">
        {{ name }}</router-link
      >
    </h3>
    <p class="price" v-if="sp != null">
      <del>₹ {{ mrp }} &mdash;</del>₹ {{ sp }}
    </p>
    <p class="price" v-else>₹ {{ mrp }}</p>
  </div>
</template>

<script>
export default {
  components: {
    Loader: () => import("@/components/Loader.vue")
  },
  data() {
    return {
      loading: false
    };
  },
  props: {
    name: String,
    mrp: String,
    sp: String,
    p_data: Object
  }
};
</script>

<style></style>
